export type CompareLayout = "overlay" | "aerial";
export type CameraPreset = "aerial" | "front" | "side" | "iso";
export type ViewMode = "single" | "quad";

export const INSTANCE_SPACING = 2.6;

export function instanceOffset(
  index: number,
  count: number,
  spacing = INSTANCE_SPACING,
): { x: number; z: number } {
  const n = Math.max(1, count | 0);
  const i = Math.max(0, index | 0);
  const cols = Math.ceil(Math.sqrt(n));
  const rows = Math.ceil(n / cols);
  const col = i % cols;
  const row = Math.floor(i / cols);
  return {
    x: (col - (cols - 1) / 2) * spacing,
    z: (row - (rows - 1) / 2) * spacing,
  };
}

export function aerialSpan(count: number, spacing = INSTANCE_SPACING): number {
  const n = Math.max(1, count | 0);
  const cols = Math.ceil(Math.sqrt(n));
  return Math.max(2, (cols - 1) * spacing + 2);
}

export function cameraPresetPose(
  preset: CameraPreset,
  spanMeters: number,
): { position: [number, number, number]; target: [number, number, number] } {
  const span = Math.max(2, spanMeters || 2);
  switch (preset) {
    case "aerial":
      return {
        position: [0, Math.max(8, span * 1.4), 0.05],
        target: [0, 0, 0],
      };
    case "front":
      return {
        position: [0, 1.4, Math.max(3.6, span * 0.9)],
        target: [0, 0.9, 0],
      };
    case "side":
      return {
        position: [Math.max(3.6, span * 0.9), 1.4, 0],
        target: [0, 0.9, 0],
      };
    case "iso":
    default:
      return {
        position: [
          Math.max(3.2, span * 0.7),
          Math.max(2.4, span * 0.55),
          Math.max(3.2, span * 0.7),
        ],
        target: [0, 0.9, 0],
      };
  }
}
